/**
 * LoveLab site-wide Lenis (matches old React LenisProvider).
 * Desktop only; skipped on <768px and prefers-reduced-motion.
 */
(function () {
  var MOBILE_MAX = 767;
  var instance = null;
  var rafId = null;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function isVisible(el) {
    if (!el) return false;
    if (el.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function overlayOpen() {
    if (document.body.classList.contains('overflow-hidden')) return true;
    if (document.documentElement.classList.contains('ll-pt-active')) return true;
    if (document.documentElement.classList.contains('ll-necklace-takeover-active')) return true;
    if (document.documentElement.classList.contains('ll-necklace-takeover-pending')) return true;
    if (document.querySelector('cart-drawer.active')) return true;
    if (isVisible(document.getElementById('ll-search-modal'))) return true;
    if (isVisible(document.querySelector('[data-ll-country-panel]'))) return true;
    if (document.body.classList.contains('ll-welcome-banner-open')) return true;
    if (isVisible(document.getElementById('ll-welcome-banner'))) return true;
    var wishlist = document.getElementById('ll-wishlist-drawer');
    if (wishlist && wishlist.style.display && wishlist.style.display !== 'none') return true;
    /* Mobile filter sheets (bracelets / necklaces / earrings) */
    if (document.querySelector('[data-filter-sheet].is-open')) return true;
    return false;
  }

  function raf(time) {
    if (instance) instance.raf(time);
    rafId = requestAnimationFrame(raf);
  }

  function destroy() {
    if (rafId != null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    if (instance) {
      instance.destroy();
      instance = null;
    }
    window.lenis = undefined;
  }

  function syncOverlay() {
    if (!instance) return;
    if (overlayOpen()) instance.stop();
    else instance.start();
  }

  function create() {
    if (prefersReducedMotion() || isMobileViewport()) {
      destroy();
      return;
    }
    if (instance || typeof Lenis === 'undefined') return;

    instance = new Lenis({
      duration: 1.2,
      easing: function (t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      infinite: false,
      autoRaf: false,
    });
    window.lenis = instance;
    rafId = requestAnimationFrame(raf);
    syncOverlay();
  }

  function restart() {
    destroy();
    create();
  }

  function init() {
    create();

    var mobileMq = window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)');
    var motionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var onChange = function () {
      restart();
    };
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', onChange);
    else mobileMq.addListener(onChange);
    if (motionMq.addEventListener) motionMq.addEventListener('change', onChange);
    else motionMq.addListener(onChange);

    var observer = new MutationObserver(syncOverlay);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    ['ll-search-modal', 'll-wishlist-drawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) observer.observe(el, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    });
    document.querySelectorAll('[data-ll-country-panel], cart-drawer').forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['hidden', 'class'] });
    });
    document.querySelectorAll('[data-filter-sheet]').forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
